// extracted by mini-css-extract-plugin
export var playBtn = "PlayButton-module--playBtn---bTIk";
export var brush = "PlayButton-module--brush--1ODuS";
export var playSymbol = "PlayButton-module--playSymbol--21ysv";
export var home = "PlayButton-module--home--AD6Hf";